import { rateLimiter, rateLimitSetting } from '@unipile/db';
import { createInsertSchema, createSelectSchema } from 'drizzle-typebox';

export const RateLimiterSchema = createSelectSchema(rateLimiter);
export type RateLimiter = typeof rateLimiter.$inferSelect;

export const RateLimitSettingSchema = createSelectSchema(rateLimitSetting);
export type RateLimitSetting = typeof rateLimitSetting.$inferSelect;

export const InsertRateLimitSettingSchema = createInsertSchema(rateLimitSetting);
export type InsertRateLimitSetting = typeof rateLimitSetting.$inferInsert;
